import { Controller } from "@hotwired/stimulus";

/**
 * お知らせ画面の詳細モーダルを管理するStimulusコントローラー
 *
 * 使用場所:
 * - お知らせ画面（/notifications）の各お知らせ項目
 *
 * 主な機能:
 * - お知らせ詳細モーダルの表示・非表示制御
 * - 背景スクロール制御（モーダル表示時に無効化）
 *
 * 必要なターゲット要素:
 * - modal: お知らせ詳細モーダル要素
 *
 * 備考:
 * - 今後お知らせ画面で追加機能が必要な場合はこのコントローラーに実装予定
 */
export default class extends Controller {
  static targets = ["modal"];

  // モーダル表示
  show() {
    this.modalTarget.hidden = false;
    // 背景スクロールを無効化
    document.body.style.overflow = "hidden";
  }

  // モーダル非表示
  hide() {
    this.modalTarget.hidden = true;
    // 背景スクロールを復元
    document.body.style.overflow = "";
  }
}
